import {
  FILE_EXTENSION_JPEG,
  FILE_EXTENSION_JPG,
  FILE_EXTENSION_PNG,
  FILE_IMAGE_TYPE_ALL,
  FILE_JPEG_TYPE,
} from '../../../constants/file'
import { getBytesFromMegabytes } from '../../../utils/file'

export const QA_NAME_PHOTO_GALLERY = 'photoGallery'

export const QA_NAME_PHOTO_DROPZONE = 'photoDropzone'

export const QA_NAME_PHOTO_LIMITS = 'photoLimits'

export const QA_NAME_PHOTO_TILE = 'photoTile'

export const QA_NAME_PHOTO_POSITION = 'photoPosition'

export const QA_NAME_PHOTO_COVER_BADGE = 'photoCoverBadge'

export const QA_NAME_PHOTO_SET_COVER = 'photoSetCover'

export const QA_NAME_PHOTO_OPEN = 'photoOpen'

export const QA_NAME_PHOTO_REORDER = 'photoReorder'

export const QA_NAME_PHOTO_DELETE = 'photoDelete'

export const QA_NAME_PHOTO_RETRY = 'photoRetry'

export const QA_NAME_PHOTO_ERROR = 'photoError'

export const QA_NAME_PHOTO_DELETE_CONFIRMATION = 'photoDeleteConfirmation'

export const PHOTO_MAX_SIZE_MB = 20

export const PHOTO_MAX_SIZE = getBytesFromMegabytes(PHOTO_MAX_SIZE_MB)

export const PHOTO_ACCEPTED_EXTENSIONS = [
  FILE_EXTENSION_JPEG,
  FILE_EXTENSION_JPG,
  FILE_EXTENSION_PNG,
]

export const PHOTO_ACCEPTED_TYPES = {
  [FILE_IMAGE_TYPE_ALL]: PHOTO_ACCEPTED_EXTENSIONS,
}

export const PHOTO_REJECTION_TOO_LARGE = 'photo-too-large'

export const PHOTO_ERROR_TEXT_KEY = {
  rejectedSize: 'RentalPortal.ListingPhotoRejectedSizeKey',
  rejectedType: 'RentalPortal.ListingPhotoRejectedTypeKey',
  uploadFailed: 'RentalPortal.ListingPhotoUploadFailedKey',
}

export const PHOTO_FALLBACK_MIME_TYPE = FILE_JPEG_TYPE
